//useGlobalVariables.js

// Firestore collections
export const usersCollection = "users";
export const globalSettingsCollection = "globalSettings";
export const resourcesCollection = "resources";
export const studyGroupsCollection = "studyGroups";
export const coursesCollection = "courses";
export const assignmentsCollection = "assignments";
export const notesCollection = "notes";

// Storage paths
export const profilePicturespath = "profilePictures";
export const resourceFilesPath = "resourceFiles";

/**
 * Default global settings
 */
export const defaultGlobalSettings = {
  appName: "Success Boost",
  appVersion: "1.0.0",
  appDescription: "Academic support for university students",
  maintenanceMode: false,
  termsLastUpdated: new Date().toISOString(),
  privacyPolicyLastUpdated: new Date().toISOString(),
  maxUploadSizeMB: 10,
  maxStudyGroupSize: 20,
  superAlert: {
    showAlert: false,
    message: "",
    alertType: "info",
  },
  universities: {
    up: {
      name: "University of Pretoria",
      abbreviation: "UP",
      position: 1,
      nickname: "Tuks",
      logoUrl: "/university-logos/up.png",
      domains: ["up.ac.za", "tuks.co.za"],
      email:"@up.ac.za",
      phoneNumbers:"",
      faculties: [
        "Faculty of Economic and Management Sciences",
        "Faculty of Education",
        "Faculty of Engineering, Built Environment and Information Technology",
        "Faculty of Health Sciences",
        "Faculty of Humanities",
        "Faculty of Law",
        "Faculty of Natural and Agricultural Sciences",
        "Faculty of Theology and Religion",
        "Faculty of Veterinary Science",
      ],
      campuses: [
        "Hatfield Campus",
        "Groenkloof Campus",
        "Prinshof Campus",
        "Onderstepoort Campus",
        "Mamelodi Campus",
        "Hillcrest Campus",
        "Gordon Institute of Business Science (GIBS)"
      ]
    },
    uct: {
      name: "University of Cape Town",
      abbreviation: "UCT",
      position: 2,
      nickname: "Cape Town",
      logoUrl: "/university-logos/uct.png",
      domains: ["myuct.ac.za"],
      email:"@uct.ac.za",
      phoneNumbers:"",
      faculties: [
        "Faculty of Commerce",
        "Faculty of Engineering & the Built Environment",
        "Faculty of Health Sciences",
        "Faculty of Humanities",
        "Faculty of Law",
        "Faculty of Science",
        "Graduate School of Business",
      ],
      campuses: [
        "Upper Campus",
        "Middle Campus",
        "Lower Campus",
        "Hiddingh Campus",
        "Medical Campus",
        "Breakwater Campus"
      ]
    },
    wits: {
      name: "University of the Witwatersrand",
      abbreviation: "Wits",
      position: 3,
      nickname: "Wits",
      logoUrl: "/university-logos/wits.png",
      domains: ["wits.ac.za"],
      email:"@wits.ac.za",
      phoneNumbers:"",
      faculties: [
        "Faculty of Commerce, Law and Management",
        "Faculty of Engineering and the Built Environment",
        "Faculty of Health Sciences",
        "Faculty of Humanities",
        "Faculty of Science",
      ],
      campuses: [
        "East Campus",
        "West Campus",
        "Education Campus",
        "Medical School",
        "Management Campus",
        "Parktown Campus"
      ]
    },
  },
  levelsOfStudy: [
    "Undergraduate",
    "Honours",
    "Postgraduate",
    "Masters",
    "Doctorate",
    "Diploma",
    "Certificate"
  ],
};
